export default [
    {
        "name": "FPS_ENABLE_UPDATED_SECTION_FOUR",
        "value": true
    },
    {
        "name": "FPS_ENABLE_UPDATED_APSC_CARD_STYLE",
        "value": true
    },
    {
        "name": "FPS_ENABLED_BLUE_BANNER_CALENDAR",
        "value": false
    },
    {
        "name": "FPS_ENABLE_REPORT_RELEASE",
        "value": false,
    }
]